import type { WithId } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

import type { LocksPayload } from './types'

export const InternalActions = {
  setLock: createAction<LocksPayload>('LOCKS_SET_LOCK'),
}

export const LocksActions = {
  lockId: createAction<WithId>('LOCKS_LOCK_ID'),
}
